import { Divider, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function RecruiterScreeningBookingLandingContent() {
  return (
    <Stack spacing={8}>
      <Text variant="h3" align="center">
        Let&apos;s hop on a quick call
      </Text>

      <Stack spacing={6}>
        <Stack direction="row" sx={{ paddingX: 6 }}>
          <Text semibold variant="body1" sx={{ width: 100 }}>
            What
          </Text>
          <Stack spacing={1}>
            <Text semibold variant="body2">
              An introductory screening call with our Clipboard recruiter
            </Text>
            <Text variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
              20 minute call
            </Text>
          </Stack>
        </Stack>

        <Divider />

        <Stack direction="row" sx={{ paddingX: 6 }}>
          <Text semibold variant="body1" sx={{ width: 100 }}>
            Why
          </Text>
          <Stack spacing={1}>
            <Text semibold variant="body2">
              It&apos;s a one-time call that unlocks instant interview listings
            </Text>
            <Text variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
              Book an interview after the call
            </Text>
          </Stack>
        </Stack>

        <Divider />

        <Stack direction="row" sx={{ paddingX: 6 }}>
          <Text semibold variant="body1" sx={{ width: 100 }}>
            When
          </Text>
          <Stack spacing={1}>
            <Text semibold variant="body2">
              We can call you now or at another time of your choice
            </Text>
            <Text variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
              The sooner, the better
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
